<template>
	<Container class="pt-6 w-full bg-white">
		<PageHeading :title="$t('common.devices')"/>
	</Container>

	<TabLayout :tabs="tabs" sticky>
		<main class="flex-1 overflow-auto">
			<router-view></router-view>
		</main>
	</TabLayout>
</template>

<script>
import TabLayout from "@/Layouts/TabLayout.vue";
import PageHeading from "@/Components/PageHeading.vue";
import Container from "@/Components/Container.vue";

export default {
	name: "DevicesLayout",
	components: {Container, PageHeading, TabLayout},
	computed: {
		tabs() {
			return [
				{
          label: this.$t('layouts.devices.overview'),
					to: {name: 'devices'},
					current: this.$route.name === 'devices'
				},
				{
          label: this.$t('layouts.devices.index'),
					to: {name: 'devices.index'},
					current: this.$route.name === 'devices.index'
				},
				{
					label: this.$t('layouts.devices.recently_viewed'),
					to: {name: 'devices.recently-viewed'},
					current: this.$route.name === 'devices.recently-viewed'
				},
			].filter(t => t.permission === undefined || this.$auth.hasPermission(t.permission))
		}
	},
}
</script>

<style scoped>

</style>